<template lang="pug">
  div
    slot
      template(v-if="munId")
        strong Организатор
        v-card.ev-card.mt-2(
          outlined
          @click="openDialog"
        )
          v-card-text.text-center.py-2
            span {{ inputValue && inputValue.organization ? inputValue.organization.full_name || inputValue.name : 'Выбрать организатора' }}
            span.caption(v-if="inputValue")
              | {{ inputValue.fact_address }}
              v-icon mdi-menu-down
            v-icon.ml-2(v-else) mdi-menu-down
    v-dialog(
      v-model="dialog"
      max-width="1000"
    )
      v-card.dialog__card
        v-card-title.primary
          span.white--text Выбрать организатора
          v-btn.ml-auto(icon color="white" @click="dialog = false")
            v-icon mdi-close

        v-card-text
          light-pagination-wrapper(
            ref="dataWrapper"
            :method="getLocalOrganizers"
            :serialize-data="serializeOrganizers"
            per-page="10"
          )
            template(#content="{ content, loading }")
              v-data-table.mb-3(
                :items="content"
                :loading="loading"
                :headers="headers"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :search="searchOrganizer"
                :custom-filter="searchOrganizationName"
                hide-default-footer
              )
                template(#top)
                  v-text-field.mb-2.mt-4(
                    v-model="searchOrganizer"
                    label="Поиск организатора"
                    outlined
                    dense
                    clearable
                    hide-details
                  )
                template(#item.short_name="{ item }") {{ item.short_name }}
                template(#item.inn="{ item }") {{ item.organization.inn }}
                template(#item.fact_address="{ item }") {{ item.organization.fact_address }}
                template(#item.organization="{ item }") {{ item.organization.full_name }}
                template(#item.actions="{ item }")
                  v-btn(
                    small
                    color="primary"
                    title="Выбрать организатора"
                    :disabled="inputValue ? item.id === inputValue.id : false"
                    @click="chooseOrganizer(item)"
                  ) Выбрать
          v-alert(
            border="left"
            colored-border
            type="error"
            elevation="2"
          )
            p.
              Если в данном списке нет интересующей Вас организации,
              скорее всего она еще не подключилась к мероприятию. Повторите попытку после подключения организации.

</template>

<script>
import LightPaginationWrapper from '../global/LightPaginationWrapper.vue';

const ORGANIZERS_HEADERS = [
  { value: 'actions', text: '', sortable: false },
  { value: 'short_name', text: 'Наименование мероприятия' },
  { value: 'organization', text: 'Организатор' },
  { value: 'inn', text: 'ИНН' },
  { value: 'fact_address', text: 'Фактический адрес' },
  // { value: 'municipality_name', text: 'Муниципалитет' },
  // { value: 'region_name', text: 'Регион' },
];

export default {
  name: 'SelectEventOrganizers',
  components: {
    LightPaginationWrapper,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    regionId: {
      type: Number,
      default: null,
    },
    munId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      headers: ORGANIZERS_HEADERS,
      sortBy: null,
      sortDesc: false,
      inputValue: null,
      searchOrganizer: '',
    };
  },
  watch: {
    munId: {
      handler(val) {
        if (val) {
          this.reloadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getLocalOrganizers(params) {
      const paramsChild = {
        ...params,
        'search[root_event_id]': this.value.highest_event.id,
        'search[region_id_or_null]': this.regionId,
        'search[municipality_id_or_null]': this.munId,
        'search[status]': this.$conf.EVENT_STATUS.ACTIVE,
        'search[can_subordinate]': 0,
        expand: 'address,area,options,organization,highest_event,nominations',
      };
      return this.$api.events.getPublicEvents(paramsChild);
    },

    serializeOrganizers(event) {
      return event.organization;
    },

    chooseOrganizer(item) {
      this.inputValue = item;
      this.dialog = false;
      this.$emit('input', item);
    },

    openDialog() {
      this.dialog = true;
    },

    reloadData() {
      const { dataWrapper } = this.$refs;
      if (dataWrapper) {
        dataWrapper.reloadData();
      }
    },

    searchOrganizationName(_, search, item) {
      const { short_name, organization } = item || {};
      const { full_name } = organization || {};
      return (short_name || '').includes(search) || (full_name || '').includes(search);
    },
  },
};
</script>

<style scoped lang="scss">

  .v-select__selections span {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
  }

  .dialog__card {
    background: #fff !important;
    border-radius: 10px;
    min-height: 500px;
  }

</style>
